import { FileUploadRequest, FileActions } from "@/business/files/domain/files";
import { tokenValidation } from "@/business/auth/application/tokenValidation";
import { loadSalesReportService } from "../infrastructure/services/loadSalesReportService";

export const loadSalesReport = {
    async execute(file: File): Promise<void> {
        const request: FileUploadRequest =
            FileActions().uploadFileRequest(
                file
            );
        await loadSalesReportService.execute(await tokenValidation.execute(), request);
    },
};